<template>
  <div class="account-container">
    <!-- {{userAccount}} -->
    <va-form ref="form" type="vertical" class="lg:w-2/5">
      <va-form-item label="Status Email">
        <va-checkbox
          v-model="emailStatus"
          :checked="emailStatus === true ? true : false"
          disabled
          style="margin-bottom:5px"
        />
        <va-button type="success" @click.prevent="verifyEmail"
        >Verifikasi Email</va-button>
      </va-form-item>
      <va-form-item label="Email">
        <va-input
          width="100%"
          name="email"
          v-model="email"
          disabled
        />
      </va-form-item>
      <va-form-item label="New Email">
        <va-input
          placeholder="Isi kolom untuk mengubah email"
          width="100%"
          name="email"
          clearable
          v-model="newEmail"
          @change="handleChangeEmail"
        />
      </va-form-item>
      <va-form-item label="Password Baru">
        <va-input
          placeholder="Isi kolom untuk mengubah password"
          width="100%"
          name="new_password"
          clearable
          v-model="newPassword"
        />
      </va-form-item>
      <va-form-item label="Konfirmasi Password Baru">
        <va-input
          placeholder="Isi kolom untuk konfirmasi password baru"
          width="100%"
          name="new_password"
          clearable
          v-model="confirmNewPassword"
        />
      </va-form-item>
      <va-form-item>
        <va-button type="primary" @click.prevent="saveAccountChanges"
        >Simpan Perubahan</va-button>
      </va-form-item>
    </va-form>
  </div>
</template>

<script>
export default {
  props: {
    userAccount: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      emailStatus: this.userAccount.isVerified,
      email: this.userAccount.email,
      newEmail: null,
      newPassword: null,
      confirmNewPassword: null,
    }
  },
  methods: {
    handleChangeEmail() {
      this.emailStatus = false
    },
    verifyEmail () {
      this.$emit('verify-email')
    },
    saveAccountChanges() {
      const payload = {
        newEmail: this.newEmail,
        email: this.email,
        password: this.newPassword,
      }
      if (this.newPassword === this.confirmNewPassword && this.newPassword !== null && this.confirmNewPassword !== null) {
        this.$emit('account-change', payload)
        this.newEmail = null
        this.newPassword = null
        this.confirmNewPassword = null
      } else if (this.newEmail !== null) {
        this.$emit('account-change', payload)
        this.newEmail = null
        this.newPassword = null
        this.confirmNewPassword = null
      } else {
        console.log('new password does not matched!!')
        setTimeout(() => {
          this.notification.error({
            title: 'Error',
            message: 'Gagal Memperbaharui Akun User, Pastikan Password Baru sama dengan Konfirmasi Password Baru!',
            // duration: 3000,
          })
        }, 3000)
      }
    },
  },
}
</script>

<style>
</style>
